import { Component, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
// import { TableClickedAction } from '../../../../interface/table.interface';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {

  public closeResult: string | undefined;
  public modalOpen: boolean = false;

  @Input() title: string = "";
  @Input() message: string = "";
  @Input() windowClass: string = '';
  @Input() confirmText: string = '';
  @Input() cancelText: string = '';

  @ViewChild("confirmationModal", { static: false }) ConfirmationModal: TemplateRef<any> | undefined;

  @Output() confirmed: EventEmitter<any> = new EventEmitter();
  @Output() confirmedData: EventEmitter<any> = new EventEmitter();

  public userAction = {};

  constructor(private modalService: NgbModal) { }

  async openModal(action: string, data?: any, value?: any, title: string = '', message: string = '') {
    if (title) this.title = title;
    if (message) this.message = message;
    this.modalOpen = true;
    this.userAction = {
      actionToPerform: action,
      data: data,
      value: value,
    }
    this.modalService.open(this.ConfirmationModal, {
      ariaLabelledBy: 'Confirmation-Modal',
      centered: true,
      windowClass: `theme-modal text-center ${this.windowClass}`.trim()
    }).result.then((result) => {
      `Result ${result}`
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  confirm(value: boolean) {
    this.confirmed.emit(value);
    if (value) {
      this.confirmedData.emit(this.userAction);
    }
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

}
